import React, { useEffect, useState } from 'react'
import { Table, Switch, message } from 'antd'
import { useDispatch } from 'react-redux'
import { PageHeader } from '../Common'
import {
  fetchPracticeFeatures,
  usePracticeFeatures,
  toggleFeatureFlag,
} from '../../redux/slices/practice-features'

export default function PracticeFeatures() {
  const dispatch = useDispatch()
  const { practices, featureFlags } = usePracticeFeatures()
  const [loading, setLoading] = useState('none')

  useEffect(() => {
    setLoading('fetch')
    dispatch(fetchPracticeFeatures())
    setLoading('none')
  }, [dispatch])

  const handleToggle = async (practiceId, featureFlagId, enabled) => {
    setLoading(`toggle-${practiceId}-${featureFlagId}`)
    try {
      await toggleFeatureFlag(practiceId, featureFlagId, enabled)
      await dispatch(fetchPracticeFeatures())
      message.success('Feature flag updated successfully')
    } catch (e) {
      message.error(`Error updating feature flag: ${e.message}`)
    } finally {
      setLoading('none')
    }
  }

  const columns = [
    {
      title: 'Practice',
      dataIndex: 'name',
      key: 'name',
      width: 300,
    },
    ...(featureFlags?.map(flag => ({
      title: flag.label,
      key: flag.id,
      width: 200,
      render: (_, practice) => {
        const isEnabled = flag.practices.some(p => p.id === practice.id)
        return (
          <Switch
            onChange={checked => handleToggle(practice.id, flag.id, checked)}
            loading={loading === `toggle-${practice.id}-${flag.id}`}
            defaultChecked={isEnabled}
          />
        )
      },
    })) || []),
  ]

  return (
    <div>
      <PageHeader title="Practice Features" />
      <Table
        size="middle"
        rowKey="id"
        style={{ overflowX: 'auto' }}
        loading={loading === 'fetch'}
        dataSource={practices}
        columns={columns}
      />
    </div>
  )
}
